import { BASE_S3, COMPANY_COLORS } from 'config/consts';
import moment from 'moment';
import React, { useRef } from 'react';
import { isMobile } from 'react-device-detect';
import { useReactToPrint } from 'react-to-print';
import CupomAbstract from './CupomAbstract';

const PRINT_PAGE_STYLE = `
  @page { size: A4; margin: 18mm 15mm; }
  html, body { background: #fff !important; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
  .no-print { display: none !important; }
`;

const receiptStyles = {
  sheet: {
    maxWidth: 720,
    margin: '0 auto',
    padding: '32px 40px',
    background: '#fff',
    color: '#212121',
    border: '1px solid #e0e0e0',
    borderRadius: 8,
    boxSizing: 'border-box',
  },
  logoWrap: {
    textAlign: 'center',
    paddingBottom: 20,
    borderBottom: '2px solid #212121',
  },
  title: { fontSize: 22, fontWeight: 600, textAlign: 'center', margin: '24px 0 4px' },
  subtitle: { fontSize: 13, color: '#616161', textAlign: 'center', margin: 0 },
  meta: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: 8,
    margin: '24px 0 16px',
    padding: '12px 16px',
    background: '#f5f5f5',
    borderRadius: 6,
    fontSize: 14,
  },
  metaLabel: { display: 'block', fontSize: 11, textTransform: 'uppercase', color: '#757575' },
  table: { width: '100%', borderCollapse: 'collapse', fontSize: 14 },
  th: {
    textAlign: 'left',
    padding: '10px 8px',
    borderBottom: '2px solid #212121',
    fontSize: 12,
    textTransform: 'uppercase',
    color: '#424242',
  },
  td: { padding: '10px 8px', borderBottom: '1px solid #e0e0e0', verticalAlign: 'top' },
  totals: { marginTop: 20, textAlign: 'right', fontSize: 14 },
  total: { fontSize: 20, fontWeight: 700, marginTop: 4 },
  footer: {
    marginTop: 32,
    paddingTop: 12,
    borderTop: '1px solid #e0e0e0',
    textAlign: 'center',
    fontSize: 11,
    color: '#757575',
  },
};

export default function OrderModal({ open, onClose, item }) {
  const receiptRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => receiptRef.current,
    documentTitle: `Pedido-${item.order_reference || item.id}`,
    pageStyle: PRINT_PAGE_STYLE,
  });

  const itemsId = item.single_product_orders.map((i) => i.product_id);
  const uniqueItemsId = Array.from(new Set(itemsId));

  function renderList() {
    const newArray = [];
    for (let productId of uniqueItemsId) {
      const product = item.single_product_orders.filter(
        (i) => i.product_id === productId
      );
      newArray.push({
        product: product[0].product.name,
        quantity: product.length,
        delivery_location: item.delivery_location
          ? item.delivery_location.name
          : null,
        date: moment(product[0].createdAt || item.createdAt).format('DD-MM-YYYY HH:mm'),
      });
    }
    return (
      <table style={receiptStyles.table}>
        <thead>
          <tr>
            <th style={{ ...receiptStyles.th, width: 90 }}>Qtd.</th>
            <th style={receiptStyles.th}>Produto</th>
            {item.delivery_location && (
              <th style={receiptStyles.th}>Local de entrega</th>
            )}
            <th style={{ ...receiptStyles.th, textAlign: 'right' }}>Data da compra</th>
          </tr>
        </thead>
        <tbody>
          {newArray.map((row) => (
            <tr key={row.product}>
              <td style={receiptStyles.td}>{row.quantity}</td>
              <td style={receiptStyles.td}>{row.product}</td>
              {item.delivery_location && (
                <td style={receiptStyles.td}>{row.delivery_location}</td>
              )}
              <td style={{ ...receiptStyles.td, textAlign: 'right' }}>{row.date}</td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  }

  function renderFullPrice() {
    if (item.source === 'payment_link') {
      return (
        <div style={receiptStyles.totals}>
          <div>{item.status}</div>
          <div style={receiptStyles.total}>
            Total: R$ {Number(item.final_value).toFixed(2).replace('.', ',')}
          </div>
        </div>
      );
    }
    if (item.action.type_id === 3) {
      if (item.single_product_orders && item.delivery_location) {
        const valuesArray = item.single_product_orders.map((item) => ({
          value: item.product.value,
          discount_value: item.product.discount_value,
        }));
        let finalPrice = 0;
        for (let price of valuesArray) {
          finalPrice +=
            parseFloat(price.value) - parseFloat(price.discount_value);
        }
        finalPrice = finalPrice + parseFloat(item.delivery_location.price);
        return (
          <div style={receiptStyles.totals}>
            <div style={receiptStyles.total}>
              Preço final: R$ {finalPrice.toFixed(2).replace('.', ',')}
            </div>
          </div>
        );
      } else return null;
    } else if (item.action.type_id === 14) {
      if (item.single_product_orders && item.delivery_location) {
        const pricesArray = item.single_product_orders.map(
          (item) => item.product.value
        );
        pricesArray.push(item.delivery_location.price);
        let finalPrice = 0;
        for (let price of pricesArray) {
          finalPrice += parseFloat(price);
        }
        finalPrice = finalPrice - parseFloat(item.action.discount_delivery);
        return (
          <div style={receiptStyles.totals}>
            <div style={receiptStyles.total}>
              Preço final: R$ {finalPrice.toFixed(2).replace('.', ',')}
            </div>
          </div>
        );
      } else return null;
    }
  }

  if (item.action.type_id === 3) {
    return <CupomAbstract item={item} />;
  }

  return (
    <div
      className="container-fluid h-100 py-4"
      style={{ backgroundColor: '#fff' }}
    >
      <div ref={receiptRef} style={receiptStyles.sheet}>
        <div style={receiptStyles.logoWrap}>
          <img
            src={`${BASE_S3}/${COMPANY_COLORS.homepage.sidebar.logo}`}
            alt="LOGO-EMPRESA"
            style={{ maxWidth: 220, maxHeight: 70, height: 'auto' }}
          />
        </div>
        <h4 style={receiptStyles.title}>{item.action.name}</h4>
        <p style={receiptStyles.subtitle}>Comprovante de pedido</p>

        <div style={receiptStyles.meta}>
          <div>
            <span style={receiptStyles.metaLabel}>Pedido</span>
            <strong>#{item.order_reference || item.id}</strong>
          </div>
          <div>
            <span style={receiptStyles.metaLabel}>Gerado em</span>
            <strong>{moment(item.createdAt).format('DD/MM/YYYY [às] HH:mm')}</strong>
          </div>
        </div>

        {renderList()}
        {renderFullPrice()}

        <div style={receiptStyles.footer}>
          Documento gerado em {moment().format('DD/MM/YYYY HH:mm')}
        </div>
      </div>

      <div className="no-print">
        <div className="row justify-content-center mt-4">
          <div className="col-md-auto col-11">
            <div
              className={'py-3 station-font-medium'}
              style={{
                background: COMPANY_COLORS.general.secondaryButton.background,
                color: COMPANY_COLORS.general.secondaryButton.text,
                borderRadius: 8,
                paddingLeft: isMobile ? 40 : 140,
                paddingRight: isMobile ? 40 : 140,
                cursor: 'pointer',
                fontSize: '1rem',
                textAlign: 'center',
              }}
              onClick={handlePrint}
            >
              {isMobile ? 'Salvar' : 'Imprimir'}
            </div>
          </div>
        </div>
        <div className="row justify-content-center mt-2 mb-5">
          <div className="col-auto">
            <a
              href="#/homepage"
              style={{ textDecoration: 'underline', color: '#505050' }}
            >
              Página inicial
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
